module.exports = __webpack_public_path__ + "static/video_background-b17085ae0ab98a032a0bf9e925d27e56.jpg";